export function InlineSpinner({ label }: { label: string }) {
  return (
    <span className="inline-spinner">
      <span className="inline-spinner-indicator" aria-hidden="true" />
      <span>{label}</span>
    </span>
  );
}
